module.exports = [
    {
        id: 1,
        label: "National Technological Invention Award",
    },
    {
        id: 2,
        label: "National Science and Technology Progress Award",
    },
    {
        id: 3,
        label: "National Natural Science Award",
    },
    {
        id: 4,
        label: "Information technology application and innovation working committee member units",
    },
    {
        id: 5,
        label: "High tech Enterprises",
    },
    {
        id: 6,
        label: "Tianjin high tech enterprise",
    },
    {
        id: 7,
        label: "Zhongguancun Golden Seed Enterprise",
    },
    {
        id: 8,
        label: "Tianjin - high tech enterprise",
    },
    {
        id: 9,
        label: "Maker Beijing 2020 epidemic prevention competition top 50 in China",
    },
    {
        id: 10,
        label: "2020 China's most growing new infrastructure start up company",
    },
    {
        id: 11,
        label: "The most growing enterprise in 2019",
    },
    {
        id: 12,
        label: "Excellent enterprises of innovation and entrepreneurship in China",
    },
    {
        id: 13,
        label: "ISO9001 quality management system certification",
    },
    {
        id: 14,
        label: "Intellectual property certification",
    },
    {
        id: 15,
        label: "Top ten gazelle Enterprises",
    },
    {
        id: 16,
        label: "Outstanding innovation award",
    },
    {
        id: 17,
        label: "Second prize of innovation and Entrepreneurship Competition",
    },
    {
        id: 18,
        label: "Technology innovation strategic alliance of biometric industry",
    },
    {
        id: 19,
        label: "Excellent innovative cases of smart policing",
    },
    {
        id: 20,
        label: "The most influential brand enterprise",
    },
];
